import withListarResumenProfesional from "../../hoc/Docentes/withResumenProfesional";
import ResumenCv from "../../view/components/RegistroUsuarios/PerfilProfesional/VistaPerfilProfesional/ResumenCv";

export default withListarResumenProfesional(ResumenCv);